import {ErrorHandler, Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {Order} from "../../shared/models/Order";
import {catchError, Observable, tap, throwError} from "rxjs";
import {Waiter} from "../../shared/models/waiter";
import {HttpClient} from "@angular/common/http";
import {WaiterShift} from "../../shared/models/waiter-shift";
import {AuthService} from "../auth/auth.service";
import {PrinterDto} from "../../shared/models/printer-dto";
import {CategoryDto} from "../../shared/models/category-dto";
import {MatSnackBar} from "@angular/material/snack-bar";


@Injectable({
  providedIn: 'root'
})
export class WaiterService {

  userRoles: string[] | null = [];

  private baseUrlWaiterService = environment.apiUrl + 'waiter';

  constructor(private http: HttpClient, private authService: AuthService, private errorHandler: ErrorHandler, private _snackBar: MatSnackBar) {
    this.userRoles = this.authService.getUserRole();
  }

  getAllWaiters(): Observable<any> {
    if (this.userRoles && <boolean>this.userRoles!.includes('superadmin')) {
      return this.http.get<any>(`${this.baseUrlWaiterService}/all`).pipe(
        tap(_ => this.log('get all waiters')),
        catchError(this.handleError<Waiter[]>('get all waiters for superadmin', []))
      );
    }
    return this.http.get<any>(`${this.baseUrlWaiterService}`).pipe(
      tap(_ => this.log('get all waiters')),
      catchError(this.handleError<Waiter[]>('get waiters all waiters', []))
    );
  }

  getAllActiveShiftWaiters(): Observable<any> {
    return this.http.get<any>(`${this.baseUrlWaiterService}/active`).pipe(
      tap(_ => this.log('get all active waiters shift')),
      catchError(this.handleError<WaiterShift[]>('get all active waiter shifts', []))
    );
  }

  getAllNotActiveShiftWaiters(): Observable<any> {
    if (this.userRoles && <boolean>this.userRoles!.includes('superadmin')) {
      return this.http.get<any>(`${this.baseUrlWaiterService}/notActive/allTenants`).pipe(
        tap(_ => this.log('get all not active waiters shift for all tenants')),
        catchError(this.handleError<WaiterShift[]>('get all non active waiter shifts for superadmin', []))
      );
    }
    return this.http.get<any>(`${this.baseUrlWaiterService}/notActive`).pipe(
      tap(_ => this.log('get all not active waiters shift')),
      catchError(this.handleError<WaiterShift[]>('get all non active waiter shifts', []))
    );
  }

  createWaiter(waiter: Waiter): Observable<any> {
    return this.http.post<any>(`${this.baseUrlWaiterService}`, waiter).pipe(
      tap(_ => this.log('post create waiter')),
      catchError(this.handleError<any[]>('create waiter', []))
    );
  }

  updateWaiter(waiter: Waiter): Observable<any> {
    return this.http.put<any>(`${this.baseUrlWaiterService}`, waiter).pipe(
      tap(_ => this.log('update waiter')),
      catchError(this.handleError<any[]>('update waiter', []))
    );
  }

  deleteWaiter(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlWaiterService}/${guid}`).pipe(
      tap(_ => this.log('delete waiter')),
      catchError(this.handleError<any[]>('delete waiter', []))
    );
  }

  createWaiterShift(waiterShift: WaiterShift): Observable<any> {
    return this.http.post<any>(`${this.baseUrlWaiterService}/waiterShift`, waiterShift).pipe(
      tap(_ => this.log('post create waiter shift')),
      catchError(this.handleError<WaiterShift[]>('create waiter shift', []))
    );
  }

  createWaiterShiftCheckout(waiterShift: WaiterShift): Observable<any> {
    return this.http.put<any>(`${this.baseUrlWaiterService}/waiterShiftCheckout`, waiterShift).pipe(
      tap(_ => this.log('post create waiter shift checkout')),
      catchError(this.handleError<any[]>('checkout waiter shift', []))
    );
  }

  printShiftWaiterReceipt(waiterShiftGuid: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrlWaiterService}/waiterShiftReceiptQueue/${waiterShiftGuid}`).pipe(
      tap(_ => this.log('print waiter shift receipt')),
      catchError(this.handleError<any[]>('print waiter shift receipt', []))
    );
  }

  simulateError(): Observable<any> {
    return this.http.get('/api/invalid-endpoint').pipe(
      tap(_ => this.log('simulate error')),
      catchError(this.handleError<any[]>('simulate error', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      this.errorHandler.handleError(error);

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      this._snackBar.open('Es ist ein Fehler aufgetreten.', 'Schließen', {duration: 3000});

      // Let the app keep running by returning an empty result.
      return throwError(() => error); //of(result as T);
    };
  }

  private log(message: string) {
    console.log(`WaiterService: ${message}`);
  }
}
